import messages from "messages";
import type { Dispatch, SetStateAction } from "react";
import DiagnosisCode from "../diagnosis-code";
import SimpleTextFormGroup from "../simple-text-form-group";

type Props<T> = {
  className?: string;
  readOnly?: boolean;
  code: ICDCode & { id: string; [key: string]: any };
  value: T;
  setValue?: Dispatch<SetStateAction<T>>;
};

const KEY = "problem";

// use trailing comma here to avoid `parsing error P`arsing error: JSX element ‘T’ has no corresponding closing tag` in .tsx
const DiagnosisFields = <T,>({
  className,
  readOnly,
  code,
  value,
  setValue,
}: Props<T>) => (
  <>
    {!readOnly && <DiagnosisCode className={className} code={code} />}
    <SimpleTextFormGroup
      className={className}
      controlId={KEY}
      label={messages.presentingProblem}
      readOnly={readOnly}
      value={value[KEY] || ""}
      onChange={(e) =>
        setValue &&
        setValue((s) => ({
          ...s,
          [KEY]: e.target.value,
        }))
      }
      placeholder={messages.enterYourDescription}
    />
  </>
);

export default DiagnosisFields;
